<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.7378 21.7L13.3003 18.2625" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.6997 18.3L13.2622 21.7375" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.0123 2.5L6.4873 7.0375" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.9873 2.5L23.5123 7.0375" stroke="#2C2738" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.5 9.8125C2.5 7.5 3.7375 7.3125 5.275 7.3125H24.725C26.2625 7.3125 27.5 7.5 27.5 9.8125C27.5 12.5 26.2625 12.3125 24.725 12.3125H5.275C3.7375 12.3125 2.5 12.5 2.5 9.8125Z" stroke="#2C2738" stroke-width="2"/>
    <path d="M4.375 12.5L6.1375 23.3C6.5375 25.725 7.5 27.5 11.075 27.5H18.6125C22.5 27.5 23.075 25.8 23.525 23.45L25.625 12.5" stroke="#2C2738" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
